function getItem(key: string) {
  try {
    return window.localStorage.getItem(key)
  } catch (ignored) {
    return null
  }
}

function setItem(key: string, value: string) {
  try {
    window.localStorage.setItem(key, value)
  } catch (ignored) {}
}

function removeItem(key: string) {
  try {
    window.localStorage.removeItem(key)
  } catch (ignored) {}
}

/**
 * Retrieves the stored value and deserializes it from raw JSON string
 * @param {*} key
 */
function getObject(key: string) {
  const value = getItem(key)
  if (value === undefined || value == null) {
    return value
  }
  try {
    return JSON.parse(value)
  } catch (ignored) {
    return null
  }
}

/**
 * Serializes the value into a JSON string and tries to store it.
 * @param {*} key
 * @param {*} value
 */
function setObject(key: string, value: string) {
  setItem(key, JSON.stringify(value))
}

export default {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
  getObject: getObject,
  setObject: setObject,
}
